import React, { useContext } from 'react'
import { EasybakeContext } from '../EasybakeProvider'
import Button from '@react/react-spectrum/Button'
import IconChevronLeft from '@react/react-spectrum/Icon/ChevronLeft'
import { __ } from 'i18n-for-browser'
import '../../config/i18n'

export default function BackButton ({ className }) {
    const { dispatch } = useContext(EasybakeContext)

    return (
        <Button
            className={className}
            label={__('nav_back')}
            onClick={() => dispatch({ type: 'set-page', payload: { page: 'home' } })}
            quiet
            variant="action"
            icon={<IconChevronLeft />}
        />
    )
}
